import { FormattedMessage } from "react-intl"
import classNames from "classnames"
import { Spinner } from "../../../common"

/**
 * Sticky bar that appears once at least one candidate is selected.
 *
 * Reuses the existing dark "banner" treatment from `select-cv__banner` so it
 * feels native — same dark navy background, same padding rhythm.
 */
const SelectionBar = ({ selectedCount, onClear, onProcess, processing }) => {
  if (selectedCount === 0) return null

  return (
    <div className="sourcing-action-bar">
      <div className="sourcing-action-bar__info">
        <p className="sourcing-action-bar__count">
          <span className="sourcing-action-bar__count-num">{selectedCount}</span>
          {" "}
          <FormattedMessage
            id="sourcing.selectedLabel"
            values={{ count: selectedCount }}
          />
        </p>
        <p className="sourcing-action-bar__note">
          <FormattedMessage
            id="sourcing.processing.note"
            values={{ count: selectedCount }}
          />
        </p>
      </div>
      <div className="sourcing-action-bar__actions">
        <button
          type="button"
          className="btn btn--small"
          onClick={onClear}
          disabled={processing}
        >
          <FormattedMessage id="sourcing.clear" />
        </button>
        <button
          type="button"
          className={classNames("btn primary btn--small", { disabled: processing })}
          onClick={onProcess}
          disabled={processing}
        >
          {processing
            ? <Spinner className="small" variant="light" />
            : (
              <FormattedMessage
                id="sourcing.process"
                values={{ count: selectedCount }}
              />
            )
          }
        </button>
      </div>
    </div>
  )
}

export default SelectionBar
